import { render, staticRenderFns } from "./ProductReg.vue?vue&type=template&id=3e39d634&scoped=true"
import script from "./ProductReg.vue?vue&type=script&lang=js"
export * from "./ProductReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e39d634",
  null
  
)

export default component.exports